import { render, staticRenderFns } from "./quickLinkEdit.vue?vue&type=template&id=6ce423a8&scoped=true"
import script from "./quickLinkEdit.vue?vue&type=script&lang=js"
export * from "./quickLinkEdit.vue?vue&type=script&lang=js"
import style0 from "./quickLinkEdit.vue?vue&type=style&index=0&id=6ce423a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce423a8",
  null
  
)

export default component.exports